<template lang="pug">
div
  .table-responsive.custom-table
    table.table-history
      thead
        tr
          th No.
          th ID
          th {{ $t('ui.date') }}
      tbody
        template(v-if="refereeList.length > 0")
          tr(v-for="(data, index) in refereeList")
            td {{index+1}}
            td {{data.account_id}}
            td {{ $moment(data.verified_date).format("YYYY-MM-DD HH:mm:ss") }}
        template(v-else)
          tr
            td(colspan="3") {{$t('ui.no_record')}}
  .statement-mobile
    .statement-single
      template(v-if="refereeList.length > 0")
        .statement-single-content(v-for="(data, index) in refereeList")
          .statement-detail
            .statement-detail-left ID:
            .statement-detail-right {{ data.account_id }}
          .statement-balance
            .statement-balance-left 
            .statement-balance-right {{ $moment(data.verified_date).format("YYYY-MM-DD HH:mm:ss") }}
      template(v-else)
        .text-center.py-2 {{ $t('ui.no_record') }}
  //- #modal-referee-list.modal(tabindex="-1" role="dialog")
    .modal-dialog(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{ $t('ui.referee') }}
          .arrow-left.d-block.d-lg-none(data-dismiss="modal" aria-label="Close")
            i.fas.fa-long-arrow-alt-left
          button.close.d-none.d-lg-block(type="button" data-dismiss="modal" aria-label="Close")
            span(aria-hidden="true") &times;
        .modal-body
          .modal-top-info
            .modal-top-left
              .balance-text {{ $t('ui.current_balance') }}:
              .balance-amount {{ currencyCode }} {{ $numeral($store.getters.balance).format("0,0.00") }}
            .modal-top-right
              a(href="javascript:void(0);" data-dismiss="modal" data-toggle="modal" data-target="#modal-statement")
                .btn.btn-main.btn-purple {{$t("ui.statement")}}
              //- a(href="javascript:void(0);" data-dismiss="modal" data-toggle="modal" data-target="#modal-history")
              //-   .small-nav-text
              //-     | {{ $t("ui.view_transaction_history") }}
              //-     i.fas.fa-arrow-alt-circle-right
          .tab-content.form-wrap
            .tab-pane.fade.show.active
              //- p.view-info.d-none.d-lg-block {{ refereeList.length }} {{ $t('ui.latest_transactions') }}

              //- //- desktop view
              .table-responsive.mt-3mt-3.d-none.d-lg-block
                table.table.table-history(width="100%")
                  tbody
                    tr
                      th(scope="col").text-left
                        .d-flex
                          .flex-grow-1 No.
                          //- .pointer
                          //-   i.fas.fa-sort
                      th(scope="col").text-center
                        .d-flex
                          .flex-grow-1 ID
                          //- .pointer
                          //-   i.fas.fa-sort
                      th(scope="col").text-right
                        .d-flex
                          .flex-grow-1 {{ $t('ui.date') }}
                          //- .pointer
                          //-   i.fas.fa-sort
                    template(v-if="refereeList.length > 0")
                      tr(v-for="(data, index) in refereeList")
                        td.text-left
                          div {{index+1}}
                        td.text-center
                          div {{data.account_id}}
                        td.text-right
                          div {{ $moment(data.verified_date).format("YYYY-MM-DD HH:mm:ss") }}
                    template(v-else)
                      tr
                        td(colspan="3")
                          .text-center {{ $t('ui.no_record') }}
              //- mobile view
              .history-phone.d-block.d-lg-none
                .history-wrap
                  //- p.border-bottom.border-secondary.pb-2.mb-1 {{ refereeList.length }} {{ $t('ui.latest_transactions') }}
                  .history-content
                    template(v-if="refereeList.length > 0")
                      .d-flex.history-single(v-for="data in refereeList")
                        .flex-grow-1
                          .font-weight-bold.history-type ID: 
                          .font-weight-bold.history-type {{$t('ui.date')}} 
                        .history-right
                          .font-weight-bold.history-amount.text-right {{ data.account_id }}
                          .font-weight-bold.history-amount.text-right {{ $moment(data.verified_date).format("YYYY-MM-DD HH:mm:ss") }}
                    template(v-else)
                      .text-center.my-2 {{$t('ui.no_record')}}
              .d-none.d-lg-block
                .btn-position
                  .btn-wrap
                    a(href='javascript:void(0);' data-dismiss='modal' aria-label='Close')
                      .btn.btn-main.btn-purple.btn-transaction {{ $t('ui.done') }}
</template>

<script>
export default {
  computed: {
    refereeList() {
      return this.$store.getters.refereeCount
    },
    currencyCode() {
      return this.$store.getters.currencyCode
    }
  }
};
</script>
